export const VERIFY_ICON = '/assets/images2/verify 1.png';
export const SEARCH_ICON = '/assets/dashboardImg/Search.png';
export const FILTER_ICON = '/assets/dashboardImg/dashboard3Icon.png';
export const GRID_DOTS_ICON = '/assets/dashboardImg/grid4dots.png';
export const MOBILE_ICON = '/assets/DashboardNewUser/Mobile.png';
export const INFLUENCER = '/assets/dashboardImg/dashboardInfluencer.png';
export const TWITTER_ICON = '/assets/images2/twitter_icon.png';
export const ARROW_TOP_ICON = '/assets/DashboardNewUser/arrowTop.png';